<div class="row">
  @if (showEffect) {
    <div class="col-12">
      <div class="form-group">
        <label>Hover effect</label>
        <div class="d-flex">
          @for (option of effects; track option.id) {
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              [class.align-active]="(effect || 'none') === option.id"
              (click)="setEffect(option.id)"
            >
              {{ option.label }}
            </button>
          }
        </div>
      </div>
    </div>
  }
  @if (showColors) {
    <div class="col-12">
      <div class="d-flex color-dp-input">
        <lib-gung-text-input
          [gungTranslate]="'Hover background'"
          [ngModel]="background"
          (ngModelChange)="setBackground($event)"
        ></lib-gung-text-input>
        <input class="input-color" type="color" [ngModel]="background" (ngModelChange)="setBackground($event)" />
      </div>
    </div>
    <div class="col-12">
      <div class="d-flex color-dp-input">
        <lib-gung-text-input
          [gungTranslate]="'Hover text color'"
          [ngModel]="color"
          (ngModelChange)="setColor($event)"
        ></lib-gung-text-input>
        <input class="input-color" type="color" [ngModel]="color" (ngModelChange)="setColor($event)" />
      </div>
    </div>
  }
</div>
